var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/search_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/search_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4128 22.3103H24.6307L31.1673 28.8778C31.7994 29.5099 31.7994 30.5428 31.1673 31.1749C30.5353 31.807 29.5023 31.807 28.8703 31.1749L22.3182 24.6228V23.4049L21.9019 22.9733C19.7436 24.8233 16.799 25.7791 13.6694 25.2549C9.3836 24.5303 5.9611 20.9537 5.43693 16.637C4.63527 10.1158 10.1236 4.62742 16.6448 5.42909C20.9615 5.95326 24.5382 9.37576 25.2628 13.6616C25.7869 16.7912 24.8311 19.7358 22.9811 21.8941L23.4128 22.3103ZM8.44155 15.3728C8.44155 19.2116 11.5403 22.3103 15.379 22.3103C19.2178 22.3103 22.3165 19.2116 22.3165 15.3728C22.3165 11.5341 19.2178 8.43534 15.379 8.43534C11.5403 8.43534 8.44155 11.5341 8.44155 15.3728Z",
    fill: "#D1D1D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuSearch);
export default __webpack_public_path__ + "static/media/ic_menu_search.e0685281.svg";
export { ForwardRef as ReactComponent };